import { Navbar } from 'react-bootstrap';
import { useAppContext } from 'providers/AppProvider';
import classNames from 'classnames';
import NavbarBrand from 'components/navbars/nav-items/NavbarBrand';
import NavItems from 'components/navbars/nav-items/NavItems';
import NavItemsSlim from 'components/navbars/nav-items/NavItemsSlim';
import ModuleTopNav from 'components/navbars/nav-items/ModuleTopNav';

const NavbarTopDefault = () => {
  const {
    config: { navbarTopShape, navbarTopAppearance }
  } = useAppContext();

  return (
    <Navbar
      className={classNames('navbar-top fixed-top', {
        'navbar-slim': navbarTopShape === 'slim'
        // 'navbar-darker': navbarTopAppearance === 'darker'
      })}
      expand
      variant=""
      data-navbar-appearance={navbarTopAppearance === 'darker' ? 'darker' : ''}
    >
      <div className="navbar-collapse ab-header">
        <div className="ab-header-left">
          <NavbarBrand />
        </div>

        {/* Level-1 module navigation — perfectly centered */}
        <div className="ab-header-center">
          <ModuleTopNav />
        </div>

        <div className="ab-header-right">
          {navbarTopShape === 'default' ? <NavItems /> : <NavItemsSlim />}
        </div>
      </div>
    </Navbar>
  );
};

export default NavbarTopDefault;
